// extracted by mini-css-extract-plugin
module.exports = {"def":"_type_def__dwNo9"};